import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Table as TableComponent } from '@src/shared/ui/components/TableStatic';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { orderBy } from 'lodash';
import React, { useMemo } from 'react';

import configuration from './configuration.json';

/**
 * RecordActivity
 *
 * This is for Records/Sources that are newly added or removed.  What info changed since the last time that IRE sent
 * the risk.
 *
 * @param addedRecords
 * @param removedRecords
 * @returns {Element}
 * @constructor
 */
export function RecordActivity({ addedRecords = [], removedRecords = [] }) {
  /**
   * renderCellAction
   *
   * displays the color coded action in a cell.
   *
   * @param cell
   * @returns {Element}
   */
  const renderCellAction = ({ cell }) => {
    if (cell?.value === 'Added') {
      return (
        <Badge outline variant="success">
          Added
        </Badge>
      );
    }

    if (cell?.value === 'Removed') {
      return (
        <Badge outline variant="error">
          Removed
        </Badge>
      );
    }

    return null;
  };

  /**
   * Columns for table.
   */
  const columns = useMemo(() => {
    return orderBy(configuration?.initialColumns, ['order'], ['asc']).map((item) => {
      const column = item;

      if (column.Header === 'Action') {
        column.Cell = renderCellAction;
      }

      return column;
    });
  }, []);

  /**
   * Rows for table.
   */
  const rows = useMemo(() => {
    return [
      ...addedRecords.map((record) => {
        return { ...record, action: 'Added' };
      }),
      ...removedRecords.map((record) => {
        return { ...record, action: 'Removed' };
      }),
    ];
  }, [addedRecords, removedRecords]);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/TrustedValueHistory/components/Table/components/ExpansionRow/components/RecordActivity/RecordActivity.jsx">
      <Heading
        css={{ marginBottom: 'var(--abyss-space-md) !important', marginTop: 'var(--abyss-space-sm)' }}
        offset={5}
      >
        Record Activity
      </Heading>
      <TableComponent
        {...{
          accessor: 'eidSearch-trustedValueHistory-RecordActivity',
          columns,
          configuration,
          noDataMessage: 'No records found.',
          rows,
        }}
      />
    </ErrorHandler>
  );
}
